import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import API from '../pages/Services/Baseservice';
import { LanguageContext } from '../pages/languagecontext';
import ClipLoader from "react-spinners/ClipLoader";
import { slugify } from '../utils/slugify';
import SEO from "./SEO";
import { getServiceSEO } from "./seoConfig";
const ExpressEntry = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { selectedLanguage } = useContext(LanguageContext);
    const location = useLocation();
    const home = () => {
        navigate("/")
    }
    const [serviceId, setServiceId] = useState(location.state?.id || null);
    const [expressentry, setExpressEntry] = useState("")
    const [chooseus, setChooseUs] = useState("");
    const [labels, setLabels] = useState("");
    const [loading, setLoading] = useState(true);
    const [gallery, setGallery] = useState("")
    const [galleryList, setGalleryList] = useState("")
    const [galleryimages, setGalleryImages] = useState("");
    const prevLanguage = useRef(selectedLanguage.id);
    const [visibleCount, setVisibleCount] = useState(3);
    const [startindex, setStartIndex] = useState(0);
    const [servicesList, setServiceList] = useState([]);
    const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
    const contentRef = useRef(null);
    const parentRef = useRef(null);
    const imageRef = useRef(null);
    const chooseImageRef = useRef(null);
    const chooseContentRef = useRef(null);
    const chooseParentRef = useRef(null)
    const seoData = expressentry && serviceId
        ? getServiceSEO(serviceId, selectedLanguage.id, expressentry)
        : null;
    useEffect(() => {
        // If we already have the id from state, use it directly
        if (location.state?.id) {
            setServiceId(location.state.id);
            return;
        }

        // Otherwise resolve id from slug via the services list
        const stored = localStorage.getItem("DropDownValue");
        if (stored) {
            const services = JSON.parse(stored);
            const match = services.find(s => slugify(s.heading) === slug);
            if (match) {
                setServiceId(match.listofservice_id);
            }
        } else {
            // Fetch if localStorage is empty
            const req = { language_id: selectedLanguage.id };
            API.post("weblistofservice_list/webCondition", req).then((res) => {
                if (res.data.success === true) {
                    const services = res.data.data.data;
                    localStorage.setItem("DropDownValue", JSON.stringify(services));
                    const match = services.find(s => slugify(s.heading) === slug);
                    if (match) setServiceId(match.listofservice_id);
                }
            });
        }
    }, [slug, selectedLanguage.id]);
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth < 992) {
                if (imageRef.current) {
                    imageRef.current.style.position = "static";
                    imageRef.current.style.top = "auto";
                    imageRef.current.style.width = "100%";
                }
                return;
            }
            if (!imageRef.current || !contentRef.current || !parentRef.current) return;

            const image = imageRef.current;
            const content = contentRef.current;
            const parent = parentRef.current;

            const imageHeight = image.offsetHeight;
            const contentHeight = content.offsetHeight;
            const parentRect = parent.getBoundingClientRect();
            const scrollTop = window.scrollY;
            const parentTop = parent.offsetTop;
            const parentBottom = parentTop + parent.offsetHeight;

            const header = document.querySelector('header') || document.querySelector('.header');
            const headerHeight = header ? header.offsetHeight : 80;
            const offsetTop = headerHeight + 20;

            if (imageHeight >= contentHeight) {
                image.style.position = "static";
                image.style.top = "auto";
                return;
            }

            const scrollPosition = scrollTop + offsetTop;

            if (scrollPosition < parentTop) {
                image.style.position = "static";
                image.style.top = "auto";
                image.style.width = "100%";
            }
            else if (scrollPosition + imageHeight < parentTop + contentHeight) {
                image.style.position = "fixed";
                image.style.top = offsetTop + 50 + "px";
                image.style.width = image.parentElement.offsetWidth - 20 + "px";
            }
            else {
                image.style.position = "absolute";
                image.style.top = (contentHeight - imageHeight) + "px";
                image.style.width = "100%";
            }
        };

        setTimeout(handleScroll, 100);
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [loading, expressentry]);
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth < 992) {
                if (chooseImageRef.current) {
                    chooseImageRef.current.style.position = "static";
                    chooseImageRef.current.style.top = "auto";
                    chooseImageRef.current.style.width = "100%";
                }
                return;
            }

            if (!chooseImageRef.current || !chooseContentRef.current || !chooseParentRef.current) return;

            const image = chooseImageRef.current;
            const content = chooseContentRef.current;
            const parent = chooseParentRef.current;

            const imageHeight = image.offsetHeight;
            const contentHeight = content.offsetHeight;
            const parentTop = parent.offsetTop;

            const header = document.querySelector('header') || document.querySelector('.header');
            const headerHeight = header ? header.offsetHeight : 80;
            const offsetTop = headerHeight + 20;

            if (imageHeight >= contentHeight) {
                image.style.position = "static";
                image.style.top = "auto";
                image.style.width = "100%";
                return;
            }

            const scrollPosition = window.scrollY + offsetTop;

            if (scrollPosition < parentTop) {
                image.style.position = "static";
                image.style.top = "auto";
                image.style.width = "100%";
            }

            else if (scrollPosition + imageHeight < parentTop + contentHeight) {
                image.style.position = "fixed";
                image.style.top = offsetTop + 50 + "px";
                image.style.width = image.parentElement.offsetWidth + "px";
            }

            else {
                image.style.position = "absolute";
                image.style.top = (contentHeight - imageHeight) + "px";
                image.style.width = image.parentElement.offsetWidth + "px";
            }
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);
        setTimeout(handleScroll, 100);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [loading, chooseus]);

    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);

        return () => clearTimeout(timer);
    }, [location.state?.id, selectedLanguage.id]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setVisibleCount(1);
            } else {
                setVisibleCount(3);
            }
            setStartIndex(0);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNext = () => {
        if (startindex + visibleCount < galleryimages.length) {
            setStartIndex(prev => prev + 1);
        }
    };

    const handlePrev = () => {
        if (startindex > 0) {
            setStartIndex(prev => prev - 1);
        }
    };

    useEffect(() => {
        if (
            prevLanguage.current !== selectedLanguage.id &&
            location.pathname !== "/service"
        ) {
            navigate("/service", {
                state: { language_id: selectedLanguage.id }
            });
        }
        prevLanguage.current = selectedLanguage.id;
    }, [selectedLanguage.id]);

    useEffect(() => {
        if (serviceId) {
            const langId = location.state?.language_id || selectedLanguage.id;
            expressEntry(serviceId, langId);
            ourgallery(langId);
            dropdown();
        }
    }, [serviceId, selectedLanguage.id]);

    const expressEntry = (serviceId, langId) => {
        setLoading(true);
        const req = {
            listofservice_id: serviceId,
            language_id: langId
        };
        API.post("webservicepage_list/webCondition", req)
            .then((res) => {
                if (res.data.success === true) {
                    setExpressEntry(res.data.data.list_of_service[0]);
                    setChooseUs(res.data.data.whychooseus[0]);
                    setLabels(res.data.data.wcu_labels);
                    setLoading(false);
                }
            });
    };

    const ourgallery = (langId) => {
        let req = {
            language_id: langId
        }
        API.post("webourgallery_list/webCondition", req).then((res) => {
            if (res.data.success === true) {
                setGalleryList(res.data.data.data);
                setGallery(res.data.data.data[0]);
                setGalleryImages(res.data.data.data[0]?.images || []);
            }
        })
    }

    const bookConsultation = (e) => {
        e.preventDefault();
        navigate("/bookingform", {
            state: {
                listofservice_id: serviceId,
                language_id: selectedLanguage.id
            }
        });
    };

    const servicesPage = (e) => {
        e.preventDefault();
        navigate("/service");
    };

    useEffect(() => {
        if (servicesList.length > 0 && serviceId) {
            const index = servicesList.findIndex(
                service => service.listofservice_id === serviceId
            );
            setCurrentServiceIndex(index !== -1 ? index : 0);
        }
    }, [servicesList, serviceId]);

    const renderRequirements = () => {
        if (!expressentry?.requirements) return null;

        const cleanedHTML = expressentry.requirements
            .replace(/<\/?ul>/g, '')
            .replace(/<\/?ol>/g, '')
            .trim();

        const listItems = cleanedHTML.split('</li>')
            .filter(item => item.includes('<li>'))
            .map(item => {
                const match = item.match(/<li[^>]*>(.*)/);
                return match ? match[1].trim() : item.trim();
            })
            .filter(item => item.length > 0);

        if (listItems.length === 0) return null;

        if (listItems.length === 1) {
            return (
                <div className="row mt-3">
                    <div className="col-md-12">
                        <ul>
                            <li className="mb-2" dangerouslySetInnerHTML={{ __html: listItems[0] }}></li>
                        </ul>
                    </div>
                </div>
            );
        }

        const half = Math.ceil(listItems.length / 2);
        const firstHalf = listItems.slice(0, half);
        const secondHalf = listItems.slice(half);

        return (
            <div className="row mt-3">
                <div className="col-md-6">
                    <ul>
                        {firstHalf.map((item, index) => (
                            <li className="mb-2" key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                        ))}
                    </ul>
                </div>
                <div className="col-md-6">
                    <ul>
                        {secondHalf.map((item, index) => (
                            <li className="mb-2" key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    };

    const dropdown = () => {
        let req = { language_id: selectedLanguage.id };

        API.post("weblistofservice_list/webCondition", req)
            .then((res) => {
                if (res.data.success === true) {
                    const services = ((res.data.data.data).slice().sort((a, b) => a.order_by - b.order_by))
                    setServiceList(services);
                    localStorage.setItem("DropDownValue", JSON.stringify(services));

                    if (location.state?.id) {
                        const index = services.findIndex(
                            service => service.listofservice_id === location.state.id
                        );
                        setCurrentServiceIndex(index !== -1 ? index : 0);
                    }
                }
            })
            .finally(() => setLoading(false));
    };

    const navigateToNextService = (e) => {
        e.preventDefault();

        if (servicesList.length === 0) return;

        const nextIndex = (currentServiceIndex + 1) % servicesList.length;
        const nextService = servicesList[nextIndex];
        const slug = slugify(nextService.heading);
        navigate(`/servicedetail/${slug}`, {
            state: {
                id: nextService.listofservice_id,
                language_id: selectedLanguage.id
            }
        });
    };

    return (
        <div style={{ overflowX: 'hidden' }}>
            {/* Add SEO component at the top */}
            {seoData && (
                <SEO
                    title={seoData.title}
                    description={seoData.description}
                    canonical={seoData.canonical}
                    keywords={seoData.keywords}
                    ogImage={seoData.ogImage || expressentry?.image}
                />
            )}

            {loading ? (
                <div className="d-flex justify-content-center align-items-center p-5 mt-5" style={{ height: "100vh" }}>
                    <ClipLoader color="#FF050C" size={50} />
                </div>
            ) : (
                <>
                    <div className="container px-3">
                        <section className="faq-hero container p-4 p-lg-5 rounded-5">
                            <h1>{selectedLanguage.id === 1 ? 'Services' : 'Services'}</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="#" onClick={(e) => { e.preventDefault(); home(); }} style={{ cursor: 'pointer' }}>
                                            {selectedLanguage.id === 1 ? 'Home' : 'Accueil'}
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="#" onClick={servicesPage} style={{ cursor: 'pointer' }}>
                                            {selectedLanguage.id === 1 ? 'Services' : 'Services'}
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        {expressentry?.heading || 'Express Entry'}
                                    </li>
                                </ol>
                            </nav>
                        </section>

                        <div className="blog-wrapper mt-lg-5 pt-lg-5 mb-lg-5">
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-5">
                                <h2 className="serviceheading mb-3 mb-sm-0 mt-md-5">
                                    {expressentry?.heading || 'Express Entry'}
                                </h2>
                                <a className="nav-link hero-btn-main mt-sm-4" href="#" onClick={bookConsultation} style={{ cursor: 'pointer' }}>
                                    <button className="btn btn-danger d-flex align-items-center justify-content-center rounded-5">
                                        <p className="p-0 m-0">
                                            {selectedLanguage.id === 1 ? 'Book a Consultation' : 'Réserver une consultation'}
                                        </p>
                                        <i className="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
                                    </button>
                                </a>
                            </div>

                            <hr className="d-none d-lg-block" />

                            <main className="blogmargintop mb-5" ref={parentRef}>
                                <div className="row g-4 align-items-start mt-3">
                                    <div className="col-lg-6 position-relative" >
                                        <article className="post mb-5">
                                            <img
                                                src={expressentry?.image}
                                                alt={expressentry?.heading || 'Service Image'}
                                                className="img-fluid expressimage"
                                                ref={imageRef}

                                            />
                                        </article>
                                    </div>

                                    <div className="col-lg-6 mt-lg-5 " ref={contentRef}>
                                        <div className="post-content">
                                            <h2 className="post-heading">
                                                {selectedLanguage.id === 1 ? 'Description' : 'Description'}
                                            </h2>
                                            <p className="mt-3 post-description"
                                                dangerouslySetInnerHTML={{
                                                    __html: expressentry?.description ||
                                                        ""
                                                }}
                                            />
                                        </div>

                                        <div className="post-content mt-5">
                                            <h2 className="post-heading">
                                                {selectedLanguage.id === 1 ? 'Requirements' : 'Exigences'}
                                            </h2>
                                            {renderRequirements() || null}
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                    {labels.length > 0 &&
                        <section className="whychooseus mb-lg-5">
                            <div className="container px-3" ref={chooseParentRef}>
                                <div className="row g-4 align-items-start">

                                    <div className="col-lg-6 mt-lg-5" ref={chooseContentRef}>
                                        <div className="post-content">
                                            <h2 className="chooseus-heading">
                                                {selectedLanguage.id === 1 ? 'Why Choose Us' : 'Pourquoi nous choisir'}
                                            </h2>

                                            <h2 className="chooseus-subheading">
                                                {chooseus?.heading}
                                            </h2>

                                            <p
                                                className="mt-3 post-description"
                                                dangerouslySetInnerHTML={{ __html: chooseus?.description }}
                                            />

                                            {labels.map((item, index) => (
                                                <div className="progress-wrapper mt-lg-4" key={index}>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="progress-title">{item.label_name}</span>
                                                        <span>{item.percentage}%</span>
                                                    </div>
                                                    <div className="progress-container mt-3">
                                                        <div
                                                            className="progress-bar-custom"
                                                            style={{ width: `${item.percentage}%` }}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 position-relative">
                                        <article className="post mb-4 ms-lg-5">
                                            <img
                                                ref={chooseImageRef}
                                                src={chooseus?.image}
                                                alt="Asra Expertise"
                                                className="img-fluid chooseusimg"
                                            />
                                        </article>
                                    </div>

                                </div>
                            </div>
                        </section>

                    }
                    {galleryList.length > 0 &&
                        <div className="container px-3 my-5 gallery-container">
                            <div className="post-content">
                                <h2 className="chooseus-heading">
                                    {selectedLanguage.id === 1 ? 'Our Gallery' : 'Notre Galerie'}
                                </h2>
                                <h2 className="gallery-subheading">
                                    {gallery?.heading || 'Asra Photo Gallery'}
                                </h2>
                                <p className="mt-3 post-description"
                                    dangerouslySetInnerHTML={{
                                        __html: gallery?.description ||
                                            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur quas consectetur deserunt accusantium corporis veniam doloremque blanditiis quisquam hic Totam debitis'
                                    }}
                                />
                            </div>

                            <div className="position-relative">
                                <div className="d-flex justify-content-between gap-4 gallery mt-5 mb-5">
                                    {galleryimages.length > visibleCount && (
                                        <button
                                            type="button "
                                            className="prevbuttonexpressentry1"
                                            onClick={handlePrev}
                                            disabled={startindex === 0}
                                        >
                                            <i className="bi bi-chevron-left bi-hover-bold fw-bold text-dark" style={{ fontSize: "15px", color: "white" }}></i>
                                        </button>
                                    )}

                                    {galleryimages.length > 0 &&
                                        galleryimages
                                            .slice(startindex, startindex + visibleCount)
                                            .map((item, index) => (
                                                <div className="gallery-item w-100" key={index}>
                                                    <img
                                                        src={item.image}
                                                        alt={`Gallery Image ${startindex + index + 1}`}
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            ))
                                    }

                                    {galleryimages.length > visibleCount && (
                                        <button
                                            type="button"
                                            className="nextbuttonexpressentry1"
                                            onClick={handleNext}
                                            disabled={startindex + visibleCount >= galleryimages.length}
                                        >
                                            <i className="bi bi-chevron-right bi-hover-bold text-dark fw-bold" style={{ fontSize: "15px", color: "white" }}></i>
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="btn-pair1 mb-3 mt-5">
                                {servicesList.length > 0 && (
                                    <button
                                        className="btn btn-danger d-flex align-items-center justify-content-center"
                                        onClick={navigateToNextService}
                                    >
                                        <p className="p-0 m-0">{servicesList[(currentServiceIndex + 1) % servicesList.length]?.heading || 'Service'}

                                        </p>
                                        <i className="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
                                    </button>
                                )}
                            </div>
                        </div>
                    }
                </>
            )}
        </div>
    )
}

export default ExpressEntry;